var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHatMainSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_236_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0.812988V2.89932H35.6347V23.7626H15.3846V25.849H41V23.7626H38.0161V0.812988H4ZM9.69515 4.56838C8.18681 4.573 6.7417 5.10194 5.67487 6.03991C4.60804 6.97787 4.006 8.24878 4 9.57558C4 12.3283 6.56723 14.5828 9.69515 14.5828C11.2027 14.5775 12.6468 14.0482 13.7126 13.1102C14.7784 12.1723 15.3794 10.9017 15.3846 9.57558C15.3846 6.82538 12.8202 4.56838 9.69515 4.56838ZM18.2308 6.5504V8.32378H25.3462V6.5504H18.2308ZM28.1923 6.5504V8.32378H32.4615V6.5504H28.1923ZM9.66935 6.34118C11.6433 6.34118 13.5484 7.70766 13.5484 9.5332C13.5484 11.3587 12.0565 12.9235 9.69515 12.9235C7.33386 12.9235 5.79032 11.6195 5.79032 9.5332C5.79032 7.44687 7.69541 6.34118 9.66935 6.34118ZM18.2336 11.5054L18.2308 13.1102H32.4615V11.5054H26.379H18.2336ZM4 15.8346V25.849H5.67487V17.7004H11.8326V25.849H13.9615V18.35L16.6029 19.8407C17.4354 20.2288 18.3179 20.2275 19.1489 19.8407L24.1724 17.5036L23.2585 15.9785L17.9542 18.5059L13.7126 16.3371C12.9516 15.9389 12.528 15.8349 11.8326 15.8346H4Z",
    fill: "#3C789E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_236_22",
    x: 0,
    y: 0.812988,
    width: 45,
    height: 33.0359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_22",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatMainSmall);
export default __webpack_public_path__ + "static/media/hatMainSmall.bce40012728010057006131c98871e7c.svg";
export { ForwardRef as ReactComponent };